module.exports = __webpack_public_path__ + "static/media/game(27).a1bc5e66.PNG";